<template>
  <div>专栏管理</div>
</template>

<script>
export default {};
</script>

<style></style>
